import React, { useState } from 'react';
import api from '@/lib/api';

type Props = {
    user: any;
    onAcknowledged: (updatedUser: any) => void;
};

const headingStyle: React.CSSProperties = {
    fontSize: '1.25rem',
    fontWeight: 700,
    marginBottom: '0.75rem',
};

const overlayStyle: React.CSSProperties = {
    position: 'fixed',
    inset: 0,
    backgroundColor: 'rgba(15, 12, 28, 0.72)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 100,
    padding: '1rem',
    backdropFilter: 'blur(6px)',
};

const cardStyle: React.CSSProperties = {
    width: '100%',
    maxWidth: '520px',
    background: 'linear-gradient(180deg, #fff8ef 0%, #fff 80%)',
    color: '#2d2630',
    borderRadius: '20px',
    padding: '1.75rem 1.5rem 1.5rem',
    boxShadow: '0 20px 50px rgba(0, 0, 0, 0.35)',
    border: '1px solid rgba(193, 154, 96, 0.5)',
};

const buttonStyle: React.CSSProperties = {
    width: '100%',
    padding: '0.85rem 1rem',
    fontSize: '1rem',
    fontWeight: 700,
    borderRadius: '14px',
    border: '1px solid #b08745',
    background: 'linear-gradient(180deg, #f7d29c 0%, #d6a45e 100%)',
    color: '#2d1b08',
    cursor: 'pointer',
    boxShadow: '0 6px 18px rgba(176, 135, 69, 0.35)',
    transition: 'transform 80ms ease',
};

const errorStyle: React.CSSProperties = {
    color: '#a13434',
    fontSize: '0.85rem',
    marginTop: '0.5rem',
};

export const OutageApologyModal: React.FC<Props> = ({ user, onAcknowledged }) => {
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState<string | null>(null);

    if (!user || user.maintenance_apology_20260719_acknowledged_at) return null;

    const onAcknowledge = async () => {
        if (submitting) return;
        setSubmitting(true);
        setError(null);
        try {
            const res = await api.post('/users/me/acknowledge-maintenance-apology-20260719');
            onAcknowledged(res.data);
        } catch (err: any) {
            console.error('outage acknowledge failed', err);
            setError('受信に失敗いたしました。少しお待ちいただき再度お試しくださいませ。');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div role="dialog" aria-modal="true" aria-labelledby="outage-apology-title" style={overlayStyle}>
            <div style={cardStyle}>
                <h2 id="outage-apology-title" style={headingStyle}>
                    長期メンテナンスのお詫びと御礼
                </h2>
                <p style={{ marginBottom: '0.75rem', lineHeight: 1.7 }}>
                    長時間にわたりMaisonPortalをご利用いただけない状態が続き、皆さまには大変なご不便とご心配をおかけしました。復旧をお待ちいただき、本当にありがとうございます。
                </p>
                <p style={{ marginBottom: '1.25rem', lineHeight: 1.7 }}>
                    お詫びと感謝の気持ちとして、<strong>100 Tokuポイント</strong>をプレゼントいたしました。今後ともMaisonPortalをよろしくお願いいたします。
                </p>
                <button
                    type="button"
                    style={buttonStyle}
                    disabled={submitting}
                    onClick={onAcknowledge}
                    onMouseDown={(e) => (e.currentTarget.style.transform = 'translateY(1px)')}
                    onMouseUp={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                >
                    {submitting ? '処理中…' : '確認しました'}
                </button>
                {error && <div style={errorStyle}>{error}</div>}
            </div>
        </div>
    );
};

export default OutageApologyModal;
